import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Toast, Dialog } from 'vant';
import { getTime } from '@/assets/utils/dateUtil';
import { getUserInfoByPatientid, getUserInfoByPhone as _getUserInfoByPhone, getUserInfoByPhoneNameCardID as _getUserInfoByPhoneNameCardID, unbindingWechat } from '@/api/module/user';
import { HideCardIdStr, hideName, HidePhoneStr as _HidePhoneStr } from '@/assets/utils/utils';
import { decrypt, encrypt } from "@/assets/utils/cryptoUtil";
import { removeToken } from "@/assets/utils/cache";
import { getConsentFormCount as _getConsentFormCount, getQuestionnaireTypeID, getWeChatMessageCount as _getWeChatMessageCount } from "@/api/module";
import VueQr from "vue-qr";
import Versions from "@/components/versions.vue";
export default {
  name: "index",
  components: {
    Versions: Versions,
    VueQr: VueQr
  },
  data: function data() {
    return {
      active: window.g.VUE_APP_MESSAGE_NOTIFICATION ? 4 : 3,
      userinfo: {},
      nickname: '',
      name: '',
      //显示登录用户
      phone: '',
      headimgurl: '',
      loginuser: {},
      welcomeStr: '',
      actionsUserShow: false,
      actionsUser: [],
      //手机号关联帐号动作面板数据
      userList: [],
      //手机号关联帐号数据
      task: 0,
      //待办任务数量
      // 展示二维码
      QRCodeShow: false,
      // 二维码用户的信息
      QRCodeUserInfo: '',
      //  是否显示三要素登录： 身份证手机号姓名
      showThreeElements: window.g.VUE_APP_LOGIN_THREE_ELEMENTS,
      messageCount: 0,
      // 消息数量
      messageShow: window.g.VUE_APP_MESSAGE_NOTIFICATION,
      messageInterval: null,
      // 定时器引用
      // 二维码 推荐码
      QRCodeReferral: '',
      // 展示 推荐码 二维码
      ReferralCodeShow: false,
      recommendCodeUrl: '',
      sellQrcode: false //是否展示二维码

    };
  },
  created: function created() {
    this.welcomeStr = getTime(); //微信用户信息

    if (window.g.VUE_APP_ISWECHAT == '1') {
      var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));

      if (userinfo) {
        this.userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
        this.headimgurl = this.userinfo.headimgurl;
        this.nickname = this.userinfo.nickname;
      } else {
        this.headimgurl = require("@/assets/images/user.svg");
        this.nickname = '';
      }
    } else {
      this.headimgurl = require("@/assets/images/user.svg");
      this.nickname = '';
    } //登录用户信息


    var loginuser = JSON.parse(localStorage.getItem("loginuser"));

    if (loginuser != null) {
      this.loginuser = loginuser;
    } else {
      this.$router.push({
        name: 'login'
      });
      return;
    }

    this.name = this.loginuser.name || this.nickname || '请编辑个人信息';
    this.phone = this.loginuser.phone;
    this.getConsentFormCount();
    this.getWeChatMessageCount();
    this.getUser();
  },
  filters: {
    hideCardIdStr: function hideCardIdStr(value) {
      var val = decrypt(value);
      return HideCardIdStr(val);
    },
    HidePhoneStr: function HidePhoneStr(value) {
      var val = decrypt(value);
      return _HidePhoneStr(val);
    },
    HideNameStr: function HideNameStr(value) {
      var val = decrypt(value);
      return hideName(val);
    }
  },
  methods: {
    //获取用户信息
    getUser: function getUser() {
      var _this = this;

      console.log("用户信息");
      var loginuser = JSON.parse(localStorage.getItem("loginuser"));
      getUserInfoByPatientid({
        patientid: this.$encruption(loginuser.patientid)
      }).then(function (res) {
        console.log("用户信息", res);

        if (res.data.sellQrcode == "1") {
          _this.sellQrcode = true;
        }
      });
    },
    //2024-08-19 ZLS  新增获取待办任务的数量
    getConsentFormCount: function getConsentFormCount() {
      var _this2 = this;

      var loginuser = JSON.parse(localStorage.getItem("loginuser"));

      if (loginuser == null) {
        return;
      }

      var param = {
        patientid: loginuser.patientid
      };

      _getConsentFormCount(param).then(function (res) {
        if (res.code == 200 && res.data > 0) {
          _this2.task = res.data;
        }
      });
    },
    toHome: function toHome() {
      this.$router.push({
        name: 'home'
      });
    },
    toOrders: function toOrders() {
      this.$router.push({
        name: 'orders'
      });
    },
    toTask: function toTask() {
      this.$router.push({
        name: 'letterConsent'
      });
    },
    gift: function gift() {
      Toast.fail('没有查询到优惠券');
    },
    card: function card() {
      Toast.fail('没有查询到体检卡');
    },
    toEdit: function toEdit() {
      this.$router.push({
        name: 'edituser'
      });
    },
    torelatives: function torelatives() {
      this.$router.push({
        name: 'relatives'
      });
    },
    toAbout: function toAbout() {
      this.$router.push({
        name: 'about'
      });
    },
    toReport: function toReport() {
      this.$router.push({
        name: 'report'
      });
    },
    toSurvey: function toSurvey() {
      var _this3 = this;

      var params = {
        typename: "满意度调查问卷"
      };
      getQuestionnaireTypeID(params).then(function (res) {
        if (res.code == 200) {
          _this3.typeid = res.data;

          if (_this3.typeid != null) {
            _this3.$router.push({
              name: 'survey'
            });
          } else {
            Toast.fail("【满意度调查问卷】种类未设置");
          }
        }
      });
    },
    toMessage: function toMessage() {
      this.$router.push({
        name: 'message'
      });
    },
    loginOut: function loginOut() {
      var _this4 = this;

      Dialog.confirm({
        title: '提示',
        message: '确认要退出吗？'
      }).then(function () {
        //如果有用户信息，则不进行微信登录
        var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
        var params = {
          wechatid: ""
        };

        if (userinfo != undefined) {
          params = {
            wechatid: userinfo.openid
          };
        }

        unbindingWechat(params).then(function (res) {
          if (res.code == 200) {
            Toast("解绑成功！");
            window.localStorage.removeItem("loginuser");
            localStorage.removeItem("token");

            _this4.$router.push({
              name: 'login'
            });
          }
        });
      }).catch(function () {});
    },

    /**
     * 手机号隐私保护
     * 隐藏中间四位数字
     * @param mobile
     * @returns {*}
     */
    formatPrice: function formatPrice(mobile) {
      mobile = String(mobile);

      if (!/\d{11}/.test(mobile)) {
        return mobile;
      }

      return mobile.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3');
    },
    //手机号关联多个客户选择
    getUserInfoByPhone: function getUserInfoByPhone() {
      var _this5 = this;

      var loginuser = JSON.parse(localStorage.getItem("loginuser"));
      var param = {
        phone: loginuser.phone
      };
      this.actionsUser = [];

      _getUserInfoByPhone(param).then(function (res) {
        if (res.code == 200) {
          //关联记录不止一条
          // Toast.fail("手机号绑定了多条");
          for (var i = 0; i < res.data.length; i++) {
            var obj = {};
            obj.id = res.data[i].id;
            obj.name = decrypt(res.data[i].name);
            obj.nickname = res.data[i].nickname;
            obj.reportNum = res.data[i].reportNum;

            if (obj.nickname == "") {
              obj.nickname = '昵称未设置';
            }

            obj.sexid = res.data[i].sexid;
            var sexname = "";

            if (res.data[i].sexid == "1") {
              sexname = "男";
            }

            if (res.data[i].sexid == "2") {
              sexname = "女";
            }

            obj.sexname = sexname;
            obj.className = "van-hairline--bottom";

            if (res.data[i].cardid != null) {
              obj.subname = HideCardIdStr(decrypt(res.data[i].cardid));
            }

            if (loginuser.patientid == res.data[i].patientid) {
              obj.disabled = true;
            }

            if (res.data[i].physicalno != null) {
              obj.physicalno = decrypt(res.data[i].physicalno);
            }

            _this5.actionsUser.push(obj);
          }

          _this5.actionsUserShow = true;
          _this5.userList = res.data;
        }
      });
    },
    //手机号 姓名 身份证 关联多个客户选择
    getUserInfoByPhoneNameCardID: function getUserInfoByPhoneNameCardID() {
      var _this6 = this;

      var loginuser = JSON.parse(localStorage.getItem("loginuser"));
      var param = {
        phone: loginuser.phone,
        name: loginuser.name,
        cardID: loginuser.cardid
      };
      this.actionsUser = [];

      _getUserInfoByPhoneNameCardID(param).then(function (res) {
        if (res.code == 200) {
          //关联记录不止一条
          // Toast.fail("手机号绑定了多条");
          for (var i = 0; i < res.data.length; i++) {
            var obj = {};
            obj.id = res.data[i].id;
            obj.name = decrypt(res.data[i].name);
            obj.nickname = res.data[i].nickname;
            obj.reportNum = res.data[i].reportNum;

            if (obj.nickname == "") {
              obj.nickname = '昵称未设置';
            }

            obj.sexid = res.data[i].sexid;
            var sexname = "";

            if (res.data[i].sexid == "1") {
              sexname = "男";
            }

            if (res.data[i].sexid == "2") {
              sexname = "女";
            }

            obj.sexname = sexname;
            obj.className = "van-hairline--bottom";

            if (res.data[i].cardid != null) {
              obj.subname = HideCardIdStr(decrypt(res.data[i].cardid));
            }

            if (loginuser.patientid == res.data[i].patientid) {
              obj.disabled = true;
            }

            if (res.data[i].physicalno != null) {
              obj.physicalno = decrypt(res.data[i].physicalno);
            }

            _this6.actionsUser.push(obj);
          }

          _this6.actionsUserShow = true;
          _this6.userList = res.data;
        }
      });
    },
    //选择帐号登录
    actionsUserOnSelect: function actionsUserOnSelect(action, index) {
      var currLoginuser = JSON.parse(localStorage.getItem("loginuser")); //判断点击是否当前登录

      if (currLoginuser.id == action.id) {
        return;
      }

      var loginuser = this.userList.filter(function (item) {
        return item.id == action.id;
      });
      localStorage.setItem("loginuser", JSON.stringify(loginuser[0]));
      localStorage.setItem("token", loginuser[0].token);
      this.actionsUserShow = false;
      location.reload();
    },
    toQRCode: function toQRCode() {
      this.QRCodeShow = true;
      var loginuser = JSON.parse(localStorage.getItem("loginuser"));
      var userInfo = {
        physicalno: loginuser.physicalno ? loginuser.physicalno : "",
        // 体检编号
        name: loginuser.name ? loginuser.name : "",
        // 姓名
        phone: loginuser.phone ? loginuser.phone : "",
        // 手机号
        patientid: loginuser.patientid ? loginuser.patientid : "",
        // 用户id
        cardid: loginuser.cardid ? loginuser.cardid : "" // 身份证

      };
      this.QRCodeUserInfo = JSON.stringify(userInfo);
      this.QRCodeUserInfo = encrypt(this.QRCodeUserInfo); // console.log("解密前", this.QRCodeUserInfo)
      // console.log("解密后", decrypt(this.QRCodeUserInfo))
    },
    toReferralCode: function toReferralCode() {
      // 跳转到分享界面
      this.$router.push({
        name: 'referralCode'
      }); // this.ReferralCodeShow = true
      // let loginuser = JSON.parse(localStorage.getItem("loginuser"));
      // getRecommendCode({patientId: loginuser.patientid}).then(res => {
      //   if (res.code == 200) {
      //     this.QRCodeReferral = res.data
      //     this.recommendCodeUrl = window.g.VUE_APP_RECOMMEND_CODE_URL + res.data
      //   }
      // })
      // this.QRCodeReferral = ""
    },
    getWeChatMessageCount: function getWeChatMessageCount() {
      var _this7 = this;

      if (!this.messageShow) {
        return;
      }

      var loginuser = JSON.parse(localStorage.getItem("loginuser"));

      if (!this.messageInterval) {
        _getWeChatMessageCount({
          patientID: loginuser.patientid
        }).then(function (res) {
          var messageCount = localStorage.getItem("messageCount");
          _this7.messageCount = res.data - messageCount;
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    // 或者使用 unmounted
    if (this.messageInterval) {
      clearInterval(this.messageInterval);
    }
  }
};